import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { SharedService } from '../../services/shared/shared.service';
import { PushSubscriptionInfo, RefreshSessionInfo, UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-menubar',
  templateUrl: './menubar.component.html',
  styleUrls: ['./menubar.component.scss'],
})
export class MenubarComponent implements OnInit {
  items: MenuItem[] = [];
  userMenu: MenuItem[] = [];
  private userEmail = localStorage.getItem('email');
  private readonly isTechnician = this.userService.getRoll() === 'TECNICO';
  permiso: any | null = null;
  sessionDialogVisible = false;
  refreshSessions: RefreshSessionInfo[] = [];
  loadingRefreshSessions = false;
  revokingSessionId: string | null = null;
  pushSubscriptionsDialogVisible = false;
  pushSubscriptions: PushSubscriptionInfo[] = [];
  loadingPushSubscriptions = false;
  removingPushSubscriptionId: string | null = null;
  canManageSessions = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private shareService: SharedService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.canManageSessions = this.userService.isAdministrator();
    const workShiftItem: MenuItem = {
      label: 'FICHAR',
      icon: 'pi pi-clock',
      command: () => {
        this.router.navigate(['/fichar']);
      },
    };
    // lógica para mostrar el menú adecuado según el control de acceso
    const mainItems: MenuItem[] = [
      // Administrador
      {
        visible: this.userService.getPermiso(undefined, '') ?? false,
        label: 'ADMINISTRADOR',
        icon: 'pi pi-lock',
        
        items: [
          {
            label: 'CREAR USUARIO',
            icon: 'pi pi-file-plus',
            iconStyle: { 'color': 'green' },
            command: (event) => {
              this.router.navigate(['/user/new']);
            },
          },
          {
            label: 'LISTA DE USUARIOS',
            icon: 'pi pi-fw pi-align-left',
            command: (event) => {
              this.router.navigate(['/user/list']);
            },
          },
          {
            label: 'EMAIL ACTIVAR',
            icon: 'pi pi-fw pi-align-left',
            command: (event) => {
              this.router.navigate(['/user/activar']);
            },
          },

           {
            label: 'PALABRAS CLAVE',
            icon: 'pi pi-fw pi-align-left',
            command: (event) => {
              this.router.navigate(['/user/productKeyword/list']);
            },
          },
        ],
      },
      // clientes
      {
        visible: this.userService.getPermiso('customer', 'read') ?? false,
        label: 'CLIENTES',
        icon: 'pi pi-users',
        items: [
          {
            visible: this.userService.getPermiso('customer', 'read') ?? false,
            label: 'LISTADO CLIENTES',
            icon: 'pi pi-fw pi-align-left',
            command: (event) => {
              this.router.navigate([{ outlets: { primary: 'customers', sidebar: null } }]);
            },
          },
          {
            visible: this.userService.getPermiso('customer', 'write') ?? false,
            label: 'NUEVO CLIENTE',
            icon: 'pi pi-file-plus',
            iconStyle: { 'color': 'green' },
            command: (event) => {
              this.router.navigate(['/customers/new']);
            },
          },
          {
            visible: this.userService.getPermiso('customer', 'write') ?? false,
            label: 'CONTACTOS',
            icon: 'pi pi-fw pi-align-left',
            command: (event) => {
              this.router.navigate(['/customers/contact/new']);
            },
          },
        ],
      },
      // presupuestos
      {
        visible: this.userService.getPermiso('budget', 'read') ?? false,
        label: 'PRESUPUESTOS',
        icon: 'pi pi-folder-open',
        items: [
          {
            visible: this.userService.getPermiso('budget', 'read') ?? false,
            label: 'LISTADO',
            icon: 'pi pi-folder',
            command: (event) => {
              this.router.navigate(['/budgets']);
            },
          },
          {
            visible: this.userService.getPermiso('budget', 'write') ?? false,
            label: 'NUEVO',
            icon: 'pi pi-file-plus',
            iconStyle: { 'color': 'green' },
            command: (event) => {
              this.router.navigate(['/budgets/new']);
            },
          },
          {
            visible: this.userService.getPermiso('budget', 'write') ?? false,
            label: 'MATERIALES',
            icon: 'pi pi-file-plus',
            iconStyle: { 'color': 'green' },
            command: (event) => {
              this.router.navigate(['/materials']);
            },
          },
          {
            visible: this.userService.getPermiso('budget', 'write') ?? false,
            label: 'NUEVO MATERIAL',
            icon: 'pi pi-file-plus',
            iconStyle: { 'color': 'green' },
            command: () => {
              this.router.navigate(['/materials/new']);
            },
          },
        ],
      },
      // Albaranes
      {
        visible: this.userService.getPermiso('delivery', 'read') ?? false,
        label: 'ALBARANES',
        icon: 'pi pi-book',
        items: [
          {
            visible: this.userService.getPermiso('delivery', 'read') ?? false,
            label: 'LISTADO',
            icon: 'pi pi-folder',
            command: () => {
              this.router.navigate(['/delivery']);
            },
          },
          {
            visible: (this.userService.getPermiso('delivery', 'write') && this.userService.getPermiso('budget', 'write')) ?? false,
            label: 'NUEVO',
            icon: 'pi pi-file-plus',
            iconStyle: { 'color': 'green' },
            command: () => {
              this.router.navigate(['/delivery/new']);
            },
          },
        ],
      },
      // Facturas
      {
        visible: this.userService.getPermiso('invoice', 'read') ?? false,
        label: 'FACTURAS',
        icon: 'pi pi-calculator',
        items: [
          {
            visible: this.userService.getPermiso('invoice', 'read') ?? false,
            label: 'LISTADO',
            icon: 'pi pi-fw pi-align-left',
            command: () => {
              this.router.navigate(['/invoices']);
            },
          },
          {
            visible: this.userService.getPermiso('invoice', 'write') ?? false,
            label: 'NUEVA',
            icon: 'pi pi-file-plus',
            iconStyle: { 'color': 'green' },
            command: () => {
              this.router.navigate(['/invoices/new']);
            },
          },
          // {
          //   visible: this.userService.getPermiso('delivery', 'read') ?? false,
          //   label: 'BUSCAR',
          //   icon: 'pi pi-fw pi-users',
          //   items: [
          //     {
          //       label: 'FILTRO',
          //       icon: 'pi pi-fw pi-filter',
          //       items: [
          //         {
          //           label: 'IMPRIMIR',
          //           icon: 'pi pi-fw pi-print',
          //         },
          //       ],
          //     },
          //     {
          //       icon: 'pi pi-fw pi-bars',
          //       label: 'LISTA',
          //     },
          //   ],
          // },
        ],
      },
      // OPCIONES
      {
        visible: this.userService.getPermiso('options', 'read') ?? false,
        label: 'OPCIONES',
        icon: 'pi pi-fw pi-cog',
        items: [
          {
            visible: this.userService.getPermiso('address', 'write') ?? false,
            label: 'REGISTRAR',
            icon: 'pi pi-file-edit',
            items: [
               {
                label: 'CUENTA BANCARIA',
                icon: 'pi pi-file-plus',
                iconStyle: { 'color': 'green' },
                command: () => {
                  this.router.navigate(['cuenta', 'new']);
                },
              },

              {
                label: 'PAIS',
                icon: 'pi pi-file-plus',
                iconStyle: { 'color': 'green' },
                command: () => {
                  this.router.navigate(['countries', 'new']);
                },
              },
              {
                label: 'PROVINCIA',
                icon: 'pi pi-file-plus',
                iconStyle: { 'color': 'green' },
                command: () => {
                  this.router.navigate(['provinces', 'new']);
                },
              },
              {
                label: 'LOCALIDAD',
                icon: 'pi pi-file-plus',
                iconStyle: { 'color': 'green' },
                command: () => {
                  this.router.navigate(['/towns/new']);
                },
              },
            ],
          },
          {
            separator: true
          },
          {
            visible: this.userService.getPermiso('presupuesto', 'write') ?? false,
            label: 'PRESUPUESTO',
            icon: 'pi pi-file-edit',
            items: [ 
              {
                label:'OPCIONES PRESUPUESTO',
                icon: 'pi pi-file-plus',
                iconStyle: { 'color': 'green' },
                command: () => {
                  this.router.navigate(['/budgets/options']);
                },
              }
            ]

            
          },
          {
            separator: true
          },
          {
            visible: this.userService.getPermiso('address', 'read') ?? false,
            label: 'LISTAR',
            icon: 'pi pi-folder',
            items: [
               {
                label: 'CUENTAS BANCARIAS',
                icon: 'pi pi-folder-open',
                command: () => {
                  this.router.navigate(['/cuenta']);
                },
              },
              {
                label: 'PAISES',
                icon: 'pi pi-folder-open',
                command: () => {
                  this.router.navigate(['/countries']);
                },
              },
              {
                label: 'PROVINCIAS',
                icon: 'pi pi-folder-open',
                command: () => {
                  this.router.navigate(['/provinces']);
                },
              },
              {
                label: 'LOCALIDADES',
                icon: 'pi pi-folder-open',
                command: () => {
                  this.router.navigate(['/towns']);
                },
              },
            ],
          },
        ],
      },
      //INVENTARIO
      {
        visible: this.userService.getPermiso('inventario', 'read') ?? false,
        label: 'INVENTARIO',
        icon: 'pi pi-fw pi-lightbulb',
        items: [
          {
            visible: this.userService.getPermiso('inventario', 'read') ?? false,
            label: 'ESCANEAR',
            icon: 'pi pi-fw pi-qrcode',
            command: () => {
              this.router.navigate(['/scan']);
            },
          },
          {
            visible: this.userService.getPermiso('inventario', 'read') ?? false,
            label: 'LISTAR',
            icon: 'pi pi-fw pi-folder-open',
            command: () => {
              this.router.navigate(['/inventario/list']);
            },
          },
          {
            visible: this.userService.getPermiso('inventario', 'write') ?? false,
            label: 'NUEVO',
            icon: 'pi pi-file-plus',
            iconStyle: { color: 'green' },
            command: () => {
              this.router.navigate(['/inventario/new']);
            },
          },
          {
            visible: this.userService.getPermiso('inventario', 'read') ?? false,
            label: 'SALIDA / ENTRADA',
            icon: 'pi pi-fw pi-calendar-minus',
            command: () => {
              this.router.navigate(['/inventario/movimiento/out']);
            },
          },
          {
            visible: this.userService.getPermiso('inventario', 'read') ?? false,
            label: 'CHEQUEO',
            icon: 'pi pi-verified',
            command: () => {
              this.router.navigate(['/inventario/ckeck']);
            },
          },
          {
            separator: true
          },
          {
            label: 'PROVEEDORES',
            items: [
              {
                visible: this.userService.getPermiso('inventario', 'read') ?? false,
                label: 'LISTAR',
                icon: 'pi pi-folder',
                command: () => {
                  this.router.navigate(['/inventario/suppliers/list']);
                },
              },
              {
                visible: this.userService.getPermiso('inventario', 'read') ?? false,
                label: 'NUEVO',
                icon: 'pi pi-file-plus',
                iconStyle: { color: 'green' },
                command: () => {
                  this.router.navigate(['/inventario/supplier/new']);
                },
              }
            ]
          },
          {
            label: 'FAMILIA',
            items: [
              {
                label: 'LISTAR',
                icon: 'pi pi-folder',
                command: () => {
                  this.router.navigate(['/inventario/familia/list'])
                },
              },
              {

                label: 'NUEVA',
                icon: 'pi pi-plus',
                command: () => {
                  this.router.navigate(['/inventario/familia/new'])
                },
              }
            ]
          },
          {
            label: 'MARCA',
            items: [
              {
                visible: this.userService.getPermiso('inventario', 'read') ?? false,
                label: 'LISTAR',
                icon: 'pi pi-folder',
                command: () => {
                  this.router.navigate(['/inventario/marca/list']);
                },
              },
              {
                visible: this.userService.getPermiso('inventario', 'write') ?? false,
                label: 'NUEVO',
                icon: 'pi pi-file-plus',
                iconStyle: { color: 'green' },
                command: () => {
                  this.router.navigate(['inventario/marca/new']);
                },
              },
            ],
          },
           {
            label: 'CATEGORIA',
            items: [
              {
                label: 'LISTAR',
                icon: 'pi pi-folder',
                command: () => {
                  this.router.navigate(['/inventario/category/list'])
                },
              },
              {

                label: 'NUEVA',
                icon: 'pi pi-plus',
                command: () => {
                  this.router.navigate(['/inventario/category/new'])
                },
              }
            ]
          },
           {
            label: 'RANGO FREQ.',
            items: [
              {
                label: 'LISTAR',
                icon: 'pi pi-folder',
                command: () => {
                  this.router.navigate(['/inventario/range/list'])
                },
              },
              {

                label: 'NUEVA',
                icon: 'pi pi-plus',
                command: () => {
                  this.router.navigate(['/inventario/range/new'])
                },
              }
            ]
          },
          {
            separator: true
          },
          {
            label: 'REPARACIONES',
            items: [
              {
                label: 'LISTAR',
                icon: 'pi pi-folder',
                command: () => { },
              },
              {
                label: 'NUEVO',
                icon: 'pi pi-file-plus',
                iconStyle: { color: 'green' },
                command: () => { },
              },
            ],
          },
        ],
      },
      {
        label: 'INFORMES',
        icon: 'pi pi-fw pi-print',
        items: [
          {
            visible: this.userService.getPermiso('inventario', 'read') ?? false,
            label: 'INVENTARIO',
            icon: 'pi pi-fw pi-lightbulb',
            command: () => {
              this.router.navigate(['/informes/inventario']);
            },
          },
        ]
      },
       {
        visible: (this.userService.getPermiso('personal', 'write') ?? false) || this.userService.hasAnyRole(['ADMINISTRADOR', 'COMERCIAL', 'PRODUCCION']),
        label: 'PERSONAL',
        icon: 'pi pi-fw pi-users',
        items: [
          {
            visible: this.userService.getPermiso('personal', 'read') ?? false,
            label: 'LISTADO PERSONAL',
            icon: 'pi pi-fw pi-align-left',
            command: () => {
              this.router.navigate(['/personal/list']);
            },
          },
          {
            visible: this.userService.getPermiso('personal', 'write') ?? false,
            label: 'ALTA PERSONAL',
            icon: 'pi pi-fw pi-user-plus',
            command: () => {
              this.router.navigate(['/personal/new']);
            },
          },
          {
            visible: this.userService.hasAnyRole(['ADMINISTRADOR', 'COMERCIAL', 'PRODUCCION']),
            label: 'ASIGNACION ALBARANES',
            icon: 'pi pi-fw pi-sitemap',
            command: () => {
              this.router.navigate(['/personal/asignacion']);
            },
          },
          {
            visible: this.userService.hasAnyRole(['ADMINISTRADOR', 'COMERCIAL', 'PRODUCCION']),
            label: 'FICHAJES',
            icon: 'pi pi-fw pi-clock',
            command: () => {
              this.router.navigate(['/fichajes']);
            },
          },
        ]
      },
      {
        label: 'VISTA',
        icon: 'pi pi-fw pi-eye',
        items: [
          {
            label: 'TEXTO',
            icon: 'pi pi-fw pi-bars',
            items: [
              {
                label: 'A+',
                icon: 'pi pi-fw pi-plus',
                command: () => {
                  this.shareService.changeFontSize(1);
                },
              },
              {
                label: 'A-',
                icon: 'pi pi-fw pi-minus',
                command: () => {
                  this.shareService.changeFontSize(-1);
                },
              },
              {
                label: 'RESET',
                icon: 'pi pi-fw pi-refresh',
                command: () => {
                  this.shareService.resetFontSize();
                },
              },
            ],
          },
        ],
      }
    
    ];

    this.items = this.isTechnician ? [workShiftItem] : [workShiftItem, ...mainItems];

    this.userMenu = [
      ...(this.canManageSessions
        ? [
            {
              label: 'VER CONEXIONES',
              icon: 'pi pi-desktop',
              command: () => {
                this.openSessionsDialog();
              },
            },
            {
              label: 'CERRAR CONEXIONES ACTIVAS',
              icon: 'pi pi-sign-out',
              command: () => {
                this.confirmLogoutAllSessions();
              },
            },
            {
              separator: true,
            },
          ]
        : []),
      ...(this.userService.canUsePushNotifications()
        ? [
            {
              label: 'MIS DISPOSITIVOS',
              icon: 'pi pi-mobile',
              command: () => {
                this.openPushSubscriptionsDialog();
              },
            },
            {
              separator: true,
            },
          ]
        : this.userService.hasStoredSession()
          ? [
              {
                label: 'MIS DISPOSITIVOS',
                icon: 'pi pi-mobile',
                command: () => {
                  this.openPushSubscriptionsDialog();
                },
              },
              {
                separator: true,
              },
            ]
          : []),
      {
        label: 'LOGOUT',
        icon: 'pi pi-power-off',
        command: () => {
          this.userService.logout();
        },
      },
      {
        separator: true
      },
      {
        style: { 'font-size': '0.9rem' },
        label: this.userEmail!
      }
    ];
  }

  changeFontSize(amount: number): void {
    this.shareService.changeFontSize(amount);
  }

  resetFontSize(): void {
    this.shareService.resetFontSize();
  }

  openSessionsDialog(): void {
    if (!this.canManageSessions) {
      return;
    }

    this.sessionDialogVisible = true;
    this.loadRefreshSessions();
  }

  openPushSubscriptionsDialog(): void {
    this.pushSubscriptionsDialogVisible = true;
    this.loadPushSubscriptions();
  }

  loadRefreshSessions(): void {
    if (!this.canManageSessions) {
      this.refreshSessions = [];
      return;
    }

    this.loadingRefreshSessions = true;
    this.userService.getMyRefreshSessions().subscribe({
      next: (sessions) => {
        this.refreshSessions = sessions ?? [];
        this.loadingRefreshSessions = false;
      },
      error: () => {
        this.refreshSessions = [];
        this.loadingRefreshSessions = false;
      },
    });
  }

  loadPushSubscriptions(): void {
    this.loadingPushSubscriptions = true;
    this.userService.getMyPushSubscriptions().subscribe({
      next: (subscriptions) => {
        this.pushSubscriptions = subscriptions ?? [];
        this.loadingPushSubscriptions = false;
      },
      error: () => {
        this.pushSubscriptions = [];
        this.loadingPushSubscriptions = false;
      },
    });
  }

  revokeSession(session: RefreshSessionInfo): void {
    if (!this.canManageSessions || !session?.id || this.revokingSessionId) {
      return;
    }

    this.revokingSessionId = session.id;
    this.userService.revokeRefreshSessionById(session.id).subscribe({
      next: (revoked) => {
        this.revokingSessionId = null;
        if (!revoked) {
          return;
        }

        if (session.current) {
          this.sessionDialogVisible = false;
          this.userService.logout();
          return;
        }

        this.refreshSessions = this.refreshSessions.filter((item) => item.id !== session.id);
      },
      error: () => {
        this.revokingSessionId = null;
      },
    });
  }

  removePushSubscription(subscription: PushSubscriptionInfo): void {
    if (!subscription?.id || this.removingPushSubscriptionId) {
      return;
    }

    this.removingPushSubscriptionId = subscription.id;
    this.userService.removePushSubscriptionById(subscription.id).subscribe({
      next: (result) => {
        this.removingPushSubscriptionId = null;
        this.pushSubscriptions = this.pushSubscriptions.filter((item) => item.id !== subscription.id);
        this.messageService.add({
          key: 'msg',
          severity: result.ok ? 'success' : 'warn',
          summary: 'MDG Push',
          detail: result.message,
        });
      },
      error: (err) => {
        this.removingPushSubscriptionId = null;
        this.messageService.add({
          key: 'msg',
          severity: 'error',
          summary: 'MDG Push',
          detail: err?.message || 'No se pudo eliminar el dispositivo push.',
        });
      },
    });
  }

  confirmLogoutAllSessions(): void {
    if (!this.canManageSessions) {
      return;
    }

    this.confirmationService.confirm({
      header: 'Cerrar conexiones activas',
      message: 'Se cerrarán todas las conexiones activas del sistema, incluida la sesión actual. ¿Deseas continuar?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Cerrar todas',
      rejectLabel: 'Cancelar',
      accept: () => {
        this.sessionDialogVisible = false;
        this.userService.logoutAllSessions();
      },
    });
  }
}
